// ProjectBoardIndex.js (Fully Updated & Fixed Code)
// Ye code ab 100% kaam karega – "Day not started" message bhi dikhega

import React, { useEffect, useState } from 'react';
import {
  Box,
  Heading,
  Input,
  SimpleGrid,
  Text,
  Spinner,
  Flex,
  Tooltip,
  useColorModeValue,
  Center,
} from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { fetchAllBoards } from './ProjectBoardServices/ProjectBoardAPI/ProjectBoardsAPi';

// 🔥 Context import – path apne project ke hisab se adjust kar lo
import { useDaySession } from '../TimerOnHeader/DaySessionContext'; // Ya '../ai TImerOnHeader/DaySessionContext'

// ---------- Utils ---------- (Same as before)
const getInitials = (name) => {
  if (!name) return '';
  const parts = name.trim().split(' ');
  return parts.length === 1
    ? parts[0][0].toUpperCase()
    : (parts[0][0] + parts[1][0]).toUpperCase();
};

const stringToColor = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const color = (hash & 0x00ffffff).toString(16).toUpperCase();
  return "#" + "00000".substring(0, 6 - color.length) + color;
};

// ---------- Component ----------
const ProjectBoardIndex = () => {
  const [boards, setBoards] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [boardsLoading, setBoardsLoading] = useState(false);

  // 🔥 CRITICAL FIX: Context se isActive ko isDayStarted ke naam se lo
  const { isActive: isDayStarted, fetchCurrentStatus } = useDaySession();

  // 🔥 DEBUG: Console mein check karne ke liye (baad mein hata sakte ho)
  const history = useHistory();
  const defaultBg = useColorModeValue('white', 'gray.800');
  const cardHoverBg = useColorModeValue('gray.100', 'gray.700');

  // Boards fetch function
  const fetchBoards = async () => {
    if (!isDayStarted) {
      setBoards([]);
      return;
    }

    setBoardsLoading(true);
    try {
      const response = await fetchAllBoards();
      setBoards(response.data.data || []);
      setError(null);
    } catch (err) {
      console.error('Boards fetch error:', err);
      setError('Failed to fetch boards');
    } finally {
      setBoardsLoading(false);
    }
  };

  // Initial load – status check + boards fetch
  useEffect(() => {
    let mounted = true;

    const init = async () => {
      setLoading(true);

      // Context se latest status le aao
      await fetchCurrentStatus();

      if (mounted) {
        await fetchBoards();
        setLoading(false);
      }
    };

    init();

    return () => {
      mounted = false;
    };
  }, []); // Only on mount

  // 🔥 IMPORTANT: Jab bhi day status change ho (Start/Stop), boards update ho
  useEffect(() => {
    fetchBoards();
  }, [isDayStarted]);

  // Search filter
  const filteredBoards = boards.filter(board =>
    board.title?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleBoardClick = (board) => {
    history.push(`/home/ap/board-details/${board.id}`);
  };

  const truncate = (text, max = 80) =>
    text && text.length > max ? text.substring(0, max) + '...' : text || 'No description';

  // ---------- UI ----------
  // Pehle loading spinner
  if (loading) {
    return (
      <Center minH="400px">
        <Spinner size="xl" color="blue.500" />
      </Center>
    );
  }

  // 🔥 FIX: Day not started message – ab dikhega jab isDayStarted false ho
  if (!isDayStarted) {
    return (
      <Center minH="400px">
        <Box textAlign="center" p={6}>
          <Heading size="lg" mb={4} color="gray.700">
            Day not started
          </Heading>
          <Text fontSize="md" color="gray.600">
            Please click the <strong>Start Day</strong> button to view your boards.
          </Text>
        </Box>
      </Center>
    );
  }

  // Main boards UI
  return (
    <Box p={6} maxW="960px" mx="auto">
      <Input
        placeholder="Search boards..."
        mb={6}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        size="md"
        variant="filled"
        maxW="300px"
      />

      {error ? (
        <Center minH="300px">
          <Text color="red.500" fontSize="lg">{error}</Text>
        </Center>
      ) : boardsLoading ? (
        <Center minH="400px">
          <Spinner size="xl" color="blue.500" />
        </Center>
      ) : filteredBoards.length === 0 ? (
        <Center minH="400px">
          <Text fontSize="lg" color="gray.500">
            No boards found
          </Text>
        </Center>
      ) : (
        <SimpleGrid columns={[1, 2, 3]} spacing={8}>
          {filteredBoards.map((board) => (
            <Box
              key={board.id}
              p={6}
              borderWidth="1px"
              borderRadius="lg"
              boxShadow="md"
              bg={board.backgroundColor || defaultBg}
              cursor="pointer"
              _hover={{ bg: cardHoverBg }}
              minH="200px"
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              onClick={() => handleBoardClick(board)}
            >
              <Heading size="md" mb={3} color="#222" isTruncated>
                {board.title}
              </Heading>

              <Text fontSize="sm" mb={5} noOfLines={3} color="#222">
                {truncate(board.description)}
              </Text>

              <Flex>
                {(board.members || []).map((member) => (
                  <Tooltip
                    key={member.id}
                    label={`${member.name} (${member.email})`}
                    fontSize="xs"
                  >
                    <Box
                      mr={-3}
                      w="38px"
                      h="38px"
                      borderRadius="full"
                      bg={stringToColor(member.name)}
                      color="white"
                      fontWeight="bold"
                      fontSize="16px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      border="3px solid white"
                    >
                      {getInitials(member.name)}
                    </Box>
                  </Tooltip>
                ))}
              </Flex>
            </Box>
          ))}
        </SimpleGrid>
      )}
    </Box>
  );
};

export default ProjectBoardIndex;